import { useCallback, useContext } from 'react';

import { ImmersiveModalWrapper } from 'src/components/dialogs/ImmersiveModalWrapper';
import { DialogCloseReason } from 'src/components/dialogs/types';
import { PortalConfigContext } from 'src/context/portalConfigContext';
import { Contract } from 'src/entities/Contract';
import { useAppSelector } from 'src/hooks/useStore';
import { selectClientsMap } from 'src/store/clients/types';

import { ContractPreviewModalContent } from './ContractPreviewModalContent';
import { ContractPreviewModalHeader } from './ContractPreviewModalHeader';

interface ContractPreviewModalProps {
  isOpen: boolean;
  contract: Contract | null;
  onClose: () => void;
}

export const ContractPreviewModal = ({
  isOpen,
  contract,
  onClose,
}: ContractPreviewModalProps) => {
  const { authPreferences } = useContext(PortalConfigContext);
  const clientsMap = useAppSelector(selectClientsMap);

  const handleClose = useCallback(
    (_e: unknown, _reason: DialogCloseReason) => {
      onClose();
    },
    [onClose],
  );

  if (!isOpen || !contract) return null;

  return (
    <ImmersiveModalWrapper isOpen={isOpen} onClose={handleClose}>
      <ContractPreviewModalHeader
        contract={contract}
        onClose={onClose}
        enableMagicLinks={authPreferences.enableMagicLinks}
        clientsMap={clientsMap}
      />
      <ContractPreviewModalContent contract={contract} />
    </ImmersiveModalWrapper>
  );
};
